import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import type CustomCompanyEmailTemplateModel from './custom-company-email-template.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class EmailTemplateModel extends Model {
  @attr declare templateId: string;
  @attr declare templateKey: string;
  @attr declare description: string;
  @attr declare skipSend: boolean;
  @attr declare createdAt: string;

  @hasMany('custom-company-email-template', { async: false, inverse: 'emailTemplate' })
  declare customCompanyEmailTemplates: CustomCompanyEmailTemplateModel[];

  [Type] = 'email-template' as const;
}
